module.exports = __webpack_public_path__ + "static/media/c-circle.d3b84900.png";